/**
 * Normalize boolean-like values from API (may be string "true" / "false") to boolean.
 * Used only when building form config from API response (e.g. taskDetailToFormConfig).
 */

/** Treat true, "true", "True" as true; false, "false", 0 as false; else false */
export function parseBoolean(value: unknown): boolean {
  if (value === true) return true;
  if (typeof value === "string" && value.toLowerCase() === "true") return true;
  if (value === false || value === 0) return false;
  if (typeof value === "string" && value.toLowerCase() === "false") return false;
  return false;
}
